import type { FieldSizesMapType } from "@/components/textField/types";
import { FieldSizes } from "@/components/textField/types";

const fieldSizesMap: Record<FieldSizes, FieldSizesMapType> = {
  [FieldSizes.WEB]: {
    InputProps: {
      style: {
        height: "40px",
        fontSize: "14px"
      },
      classes: {
        input: "WEB"
      }
    },
    InputLabelProps: {
      style: {
        fontSize: "14px"
      }
    }
  },
  [FieldSizes.MOBILE]: {
    InputProps: {
      style: {
        height: "50px",
        fontSize: "1rem"
      },
      classes: {
        input: "MOBILE"
      }
    },
    InputLabelProps: {
      style: {
        fontSize: "1rem"
      }
    }
  }
};

export { fieldSizesMap };
